<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">
			<PageHead label='带教老师信息' label2="修改带教老师" url="/person/teach/list"></PageHead>
			<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form"
				ref="form">
				<div class="form-group m-form__group row">
					<label class="col-xl-1 col-form-label m--align-left"
						style="font-size: 14px;color: #E6A23C;">基本信息：</label>
					<div class="col-xl-11">
					</div>
				</div>
				<div class="m-portlet__body">
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">姓名：</label>
						<div class="col-xl-3">
							<el-form-item prop="truename" :rules="{required: true, message: '姓名不能为空', trigger: 'blur'}">
								<el-input v-model="form.truename" placeholder="请输入姓名"></el-input>
							</el-form-item>
						</div>
						<label class="col-xl-2 col-form-label">工号：</label>
						<div class="col-xl-3">
							<el-form-item prop="cardno" :rules="{required: true, message: '工号不能为空', trigger: 'blur'}">
								<el-input v-model="form.cardno" placeholder="请输入工号"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">性别：</label>
						<div class="col-xl-3">
							<el-select v-model="form.sex" filterable placeholder="请选择">
								<el-option label="请选择" value=""></el-option>
								<el-option v-for="item in sexOptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
						<label class="col-xl-2 col-form-label">出生日期：</label>
						<div class="col-xl-3">
							<el-date-picker v-model="form.birthday" type="date" placeholder="选择日期"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">管理单元：</label>
						<div class="col-xl-3">
							<el-form-item prop="section"
								:rules="{required: true, message: '管理单元不能为空', trigger: 'change'}">
								<el-select v-model="form.section" filterable placeholder="请选择">
									<el-option label="请选择" value=""></el-option>
									<el-option v-for="item in managesecOptions" :key="item.DictItemID"
										:label="item.DictItemName" :value="item.DictItemID">
									</el-option>
								</el-select>
							</el-form-item>
						</div>
						<label class="col-xl-2 col-form-label">学历：</label>
						<div class="col-xl-3">
							<ZPGLFormDictItemSelect v-model='form.edu' :dictid='this.$utils.DictEnum.edu'>
							</ZPGLFormDictItemSelect>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">职称：</label>
						<div class="col-xl-3">
							<ZPGLFormDictItemSelect v-model='form.title' :dictid='this.$utils.DictEnum.title'>
							</ZPGLFormDictItemSelect>
						</div>
						<label class="col-xl-2 col-form-label">职务：</label>
						<div class="col-xl-3">
							<ZPGLFormDictItemSelect v-model='form.duty' :dictid='this.$utils.DictEnum.duty'>
							</ZPGLFormDictItemSelect>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">银行：</label>
						<div class="col-xl-3">
							<el-form-item prop="bank">
								<el-input v-model="form.bank" placeholder="请输入银行"></el-input>
							</el-form-item>
						</div>
						<label class="col-xl-2 col-form-label">卡号：</label>
						<div class="col-xl-3">
							<el-form-item prop="bankno">
								<el-input v-model="form.bankno" placeholder="请输入卡号"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">参工时间：</label>
						<div class="col-xl-3">
							<el-date-picker v-model="form.workdate" type="date" placeholder="选择日期"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</div>
						<label class="col-xl-2 col-form-label">全科师资：</label>
						<div class="col-xl-3" style="padding-top:5px;">
							<el-checkbox v-model="form.isqk">是</el-checkbox>
						</div>
					</div>
				</div>
				<div class="form-group m-form__group row">
					<label class="col-xl-1 col-form-label m--align-left"
						style="font-size: 14px;color: #E6A23C;">师资信息：</label>
					<div class="col-xl-11">
					</div>
				</div>
				<div class="m-portlet__body">
					<div class="form-group m-form__group row">
						<div class="col-xl-1">
						</div>
						<div class="col-xl-10">
							<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
								<el-table ref="multipleTable" :data="form.tecData" tooltip-effect="dark"
									style="width: 100%">
									<el-table-column prop="level" label="级别">
									</el-table-column>
									<el-table-column prop="spec" label="专业">
									</el-table-column>
									<el-table-column prop="arr" label="层次">
									</el-table-column>
									<el-table-column label="附件">
										<template slot-scope="scope">
											<span v-if="scope.row.filename == ''">无</span>
											<el-button v-if="scope.row.filename != ''" @click="See(scope.row)"
												type="text" size="medium">查看
											</el-button>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作" width="70">
										<template slot-scope="scope">
											<el-button @click.native.prevent="DeleteRow(scope.$index, form.tecData)"
												type="text" size="small">
												移除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<div class="col-xl-1">
						</div>
					</div>
					<div class="form-group m-form__group row">
						<div class="col-xl-12" style="text-align: center;">
							<el-button type="primary" icon="el-icon-circle-plus-outline" @click="AddTec">新增师资
							</el-button>
						</div>
					</div>
					<el-dialog width="30%" title="新增师资" :visible.sync="tecVisible">
						<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
							:model="tecform" ref="tecform">
							<div class="m-portlet__body">
								<div class="form-group m-form__group row">
									<label class="col-xl-4 col-form-label">级别：</label>
									<div class="col-xl-6">
										<el-form-item prop="level"
											:rules="{required: true, message: '级别不能为空', trigger: 'blur'}">
											<el-select v-model="tecform.level" filterable placeholder="请选择">
												<el-option label="请选择" value=""></el-option>
												<el-option v-for="item in levelOptions" :key="item.id"
													:label="item.name" :value="item.id">
												</el-option>
											</el-select>
										</el-form-item>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-xl-4 col-form-label">专业：</label>
									<div class="col-xl-6">
										<el-form-item prop="spec"
											:rules="{required: true, message: '专业不能为空', trigger: 'blur'}">
											<el-select v-model="tecform.spec" filterable placeholder="请选择">
												<el-option label="请选择" value=""></el-option>
												<el-option v-for="item in specOptions" :key="item.DictItemName"
													:label="item.DictItemName" :value="item.DictItemName">
												</el-option>
											</el-select>
										</el-form-item>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-xl-4 col-form-label">层次：</label>
									<div class="col-xl-6">
										<el-form-item prop="arr"
											:rules="{required: true, message: '层次不能为空', trigger: 'blur'}">
											<el-select v-model="tecform.arr" filterable placeholder="请选择">
												<el-option label="请选择" value=""></el-option>
												<el-option v-for="item in tecarrOptions" :key="item.id"
													:label="item.name" :value="item.id">
												</el-option>
											</el-select>
										</el-form-item>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-xl-4 col-form-label">附件：</label>
									<div class="col-xl-6">
										<el-upload class="upload-demo" ref="tecupload" action :limit="1"
											:show-file-list="false" :http-request="submitTecFile">
											<el-button slot="trigger" size="medium" type="primary">选取文件</el-button>
										</el-upload>
										<div v-if="this.tecform.filename!=''&&this.tecform.filename!=null">
											<el-button @click="SeeTecFile()" type="text" size="medium">查看</el-button>
										</div>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<div class="col-xl-12 m--align-center">
										<el-button type="success" icon="el-icon-s-order" @click="TecAdd()">新增
										</el-button>
									</div>
								</div>
							</div>
						</el-form>
					</el-dialog>
				</div>
				<div class="form-group m-form__group row">
					<label class="col-xl-1 col-form-label m--align-left"
						style="font-size: 14px;color: #E6A23C;">考官信息：</label>
					<div class="col-xl-11">
					</div>
				</div>
				<div class="m-portlet__body">
					<div class="form-group m-form__group row">
						<div class="col-xl-1">
						</div>
						<div class="col-xl-10">
							<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
								<el-table ref="multipleTable" :data="form.examData" tooltip-effect="dark"
									style="width: 100%">
									<el-table-column prop="level" label="级别">
									</el-table-column>
									<el-table-column prop="spec" label="专业">
									</el-table-column>
									<el-table-column prop="arr" label="层次">
									</el-table-column>
									<el-table-column label="附件">
										<template slot-scope="scope">
											<span v-if="scope.row.filename == ''">无</span>
											<el-button v-if="scope.row.filename != ''" @click="See(scope.row)"
												type="text" size="medium">查看
											</el-button>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作" width="70">
										<template slot-scope="scope">
											<el-button @click.native.prevent="DeleteRow(scope.$index, form.examData)"
												type="text" size="small">移除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<div class="col-xl-1">
						</div>
					</div>
					<div class="form-group m-form__group row">
						<div class="col-xl-12" style="text-align: center;">
							<el-button type="primary" icon="el-icon-circle-plus-outline" @click="AddExam">新增考官
							</el-button>
						</div>
					</div>
					<el-dialog width="30%" title="新增考官" :visible.sync="examVisible">
						<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
							:model="examform" ref="examform">
							<div class="m-portlet__body">
								<div class="form-group m-form__group row">
									<label class="col-xl-4 col-form-label">级别：</label>
									<div class="col-xl-6">
										<el-form-item prop="level"
											:rules="{required: true, message: '级别不能为空', trigger: 'blur'}">
											<el-select v-model="examform.level" filterable placeholder="请选择">
												<el-option label="请选择" value=""></el-option>
												<el-option v-for="item in levelOptions" :key="item.id"
													:label="item.name" :value="item.id">
												</el-option>
											</el-select>
										</el-form-item>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-xl-4 col-form-label">专业：</label>
									<div class="col-xl-6">
										<el-form-item prop="spec"
											:rules="{required: true, message: '专业不能为空', trigger: 'blur'}">
											<el-select v-model="examform.spec" filterable placeholder="请选择">
												<el-option label="请选择" value=""></el-option>
												<el-option v-for="item in specOptions" :key="item.DictItemName"
													:label="item.DictItemName" :value="item.DictItemName">
												</el-option>
											</el-select>
										</el-form-item>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-xl-4 col-form-label">层次：</label>
									<div class="col-xl-6">
										<el-form-item prop="arr"
											:rules="{required: true, message: '层次不能为空', trigger: 'blur'}">
											<el-select v-model="examform.arr" filterable placeholder="请选择">
												<el-option label="请选择" value=""></el-option>
												<el-option v-for="item in examarrOptions" :key="item.id"
													:label="item.name" :value="item.id">
												</el-option>
											</el-select>
										</el-form-item>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<label class="col-xl-4 col-form-label">附件：</label>
									<div class="col-xl-6">
										<el-upload class="upload-demo" ref="examupload" action :limit="1"
											:show-file-list="false" :http-request="submitExamFile">
											<el-button slot="trigger" size="medium" type="primary">选取文件</el-button>
										</el-upload>
										<div v-if="this.examform.filename!=''&&this.examform.filename!=null">
											<el-button @click="SeeExamFile()" type="text" size="medium">查看</el-button>
										</div>
									</div>
								</div>
								<div class="form-group m-form__group row">
									<div class="col-xl-12 m--align-center">
										<el-button type="success" icon="el-icon-s-order" @click="ExamAdd()">新增
										</el-button>
									</div>
								</div>
							</div>
						</el-form>
					</el-dialog>
				</div>
				<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
					<div class="m-form__actions m-form__actions--solid">
						<div class="row">
							<div class="col-lg-12 m--align-center">
								<SaveButton :url='saveUrl' back="/person/teach/list"></SaveButton>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TeachEdit',
		data() {
			return {
				form: {
					token: '',
					username: '',
					rolelevel: '',
					truename: '',
					cardno: '',
					sex: '',
					birthday: '',
					section: '',
					edu: '',
					duty: '',
					title: '',
					workdate: '',
					bank: '',
					bankno: '',
					tecData: [],
					examData: [],
					isqk: false
				},
				managesecOptions: [],
				specOptions: [],
				sexOptions: [{
					value: '1',
					label: '男'
				}, {
					value: '2',
					label: '女'
				}],
				levelOptions: [{
						id: '国家',
						name: '国家'
					},
					{
						id: '省级',
						name: '省级'
					},
					{
						id: '市级',
						name: '市级'
					}
				],
				tecarrOptions: [{
						id: '师资',
						name: '师资'
					},
					{
						id: '骨干师资',
						name: '骨干师资'
					}
				],
				examarrOptions: [{
						id: '技能考官',
						name: '技能考官'
					},
					{
						id: '命题考官',
						name: '命题考官'
					}
				],
				saveUrl: this.$utils.Url.zpgl + '/api/APITeacher/Update',
				tecform: {
					level: '',
					spec: '',
					arr: '',
					filename: ''
				},
				tecVisible: false,
				examform: {
					level: '',
					spec: '',
					arr: '',
					filename: ''
				},
				examVisible: false
			}
		},
		methods: {
			AddTec: function() {
				this.tecVisible = true
				this.tecform.level = ''
				this.tecform.spec = ''
				this.tecform.arr = ''
				this.tecform.filename = ''
			},
			AddExam: function() {
				this.examVisible = true
				this.examform.level = ''
				this.examform.spec = ''
				this.examform.arr = ''
				this.examform.filename = ''
			},
			TecAdd() {
				this.$refs['tecform'].validate((valid) => {
					if (valid) {
						let newLine = {
							level: this.tecform.level,
							spec: this.tecform.spec,
							arr: this.tecform.arr,
							filename: this.tecform.filename
						}
						this.form.tecData.push(newLine)
						this.tecVisible = false
					} else {
						console.log('error submit!!')
						return false;
					}
				})
			},
			ExamAdd() {
				this.$refs['examform'].validate((valid) => {
					if (valid) {
						let newLine = {
							level: this.examform.level,
							spec: this.examform.spec,
							arr: this.examform.arr,
							filename: this.examform.filename
						}
						this.form.examData.push(newLine)
						this.examVisible = false
					} else {
						console.log('error submit!!')
						return false;
					}
				})
			},
			DeleteRow(index, rows) {
				rows.splice(index, 1)
			},
			See: function(row) {
				var url = this.$utils.Url.zpgl + '/file/' + row.filename
				window.open(url)
			},
			SeeTecFile: function() {
				var url = this.$utils.Url.zpgl + '/file/' + this.tecform.filename
				window.open(url)
			},
			submitTecFile: function(param) {
				let formData = new FormData()
				formData.append('file', param.file)
				this.$http.post(this.$utils.Url.zpgl + '/api/APIDictItem/UploadFile', formData, {
						'Content-Type': 'multipart/form-data'
					})
					.then(res => {
						console.log(res.data)
						if (res.data.Code === 0) {
							this.$message({
								message: '上传成功',
								type: 'success'
							})
							this.$refs.tecupload.clearFiles()
							this.tecform.filename = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Data,
								type: 'error'
							})
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '上传失败',
							type: 'error'
						})
					})
			},
			submitExamFile: function(param) {
				let formData = new FormData()
				formData.append('file', param.file)
				this.$http.post(this.$utils.Url.zpgl + '/api/APIDictItem/UploadFile', formData, {
						'Content-Type': 'multipart/form-data'
					})
					.then(res => {
						console.log(res.data)
						if (res.data.Code === 0) {
							this.$message({
								message: '上传成功',
								type: 'success'
							})
							this.$refs.examupload.clearFiles()
							this.examform.filename = res.data.Data
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Data,
								type: 'error'
							})
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '上传失败',
							type: 'error'
						})
					})
			},
			LoadManageSec: function() {
				var args = {
					token: this.form.token,
					username: this.form.username,
					rolelevel: this.form.rolelevel
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
					that.managesecOptions = data.Data
					that.LoadTecInfo()
				}, null, null, null)
			},
			LoadTecInfo: function() {
				// 获取数据字典信息
				var args = {
					id: this.form.id,
					token: this.form.token
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APITeacher/Info', args, function(data, model) {
					model.truename = data.Data.TrueName
					model.cardno = data.Data.CardNo
					if (data.Data.Sex != null) {
						model.sex = String(data.Data.Sex)
					}
					model.birthday = data.Data.Birthday
					if (data.Data.Section != null) {
						model.section = data.Data.Section
					}
					if (data.Data.Edu != null) {
						model.edu = data.Data.Edu
					}
					if (data.Data.Duty != null) {
						model.duty = data.Data.Duty
					}
					if (data.Data.Title != null) {
						model.title = data.Data.Title
					}
					model.workdate = data.Data.WorkDate
					model.bank = data.Data.Bank
					model.bankno = data.Data.BankNo
					model.isqk=data.Data.TecRemark1=='True'?true:false
					that.LoadTec()
				}, null, null, this.form)
			},
			LoadTec: function() {
				// 获取数据字典信息
				var args = {
					token: this.form.token,
					id: this.form.id,
					infotype: 1
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APITeacher/GetTec', args, function(data) {
					for (var i = 0; i < data.Data.length; i++) {
						var arg = {
							level: data.Data[i]["LevelName"],
							spec: data.Data[i]["SpecName"],
							arr: data.Data[i]["ArrName"],
							filename: data.Data[i]["FileName"]
						}
						that.form.tecData.push(arg)
					}
					that.LoadExam()
				}, null, null, null)
			},
			LoadExam: function() {
				// 获取数据字典信息
				var args = {
					token: this.form.token,
					id: this.form.id,
					infotype: 2
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APITeacher/GetTec', args, function(data) {
					for (var i = 0; i < data.Data.length; i++) {
						var arg = {
							level: data.Data[i]["LevelName"],
							spec: data.Data[i]["SpecName"],
							arr: data.Data[i]["ArrName"],
							filename: data.Data[i]["FileName"]
						}
						that.form.examData.push(arg)
					}
				}, null, null, null)
			},
			LoadSpec: function() {
				var args = {
					token: this.form.token,
					userid: this.form.userid,
					rolelevel: this.form.rolelevel,
					dictid: this.$utils.DictEnum.specialty
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/DictList', args, function(data) {
					that.specOptions = data.Data
				}, null, null, null)
			}
		},
		mounted: function() {
			this.form.token = sessionStorage.getItem('token')
			this.form.username = sessionStorage.getItem('username')
			this.form.rolelevel = sessionStorage.getItem('rolelevel')
			this.form.id = this.$route.params.id
			this.LoadManageSec()
			this.LoadSpec()
		}
	}
</script>

<style scoped="scoped">
	.el-form-item {
		margin-bottom: 0px;
	}

	.el-select {
		width: 100%;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100%;
	}
</style>
